import {inject, Injectable} from "@angular/core";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ErrorSnackbarComponent, ErrorSnackbarData} from "../components/snackbars/error-snackbar/error-snackbar.component";
import {SuccessSnackbarComponent, SuccessSnackbarData} from "@common/components/snackbars/success-snackbar/success-snackbar.component";
import {SimStatusPalette} from "@models";
import {InfoSnackbarComponent, InfoSnackbarData} from "@common/components/snackbars/info-snackbar/info-snackbar.component";

@Injectable({
	providedIn: "root",
})
export class NotificationService {
	readonly #snackBar = inject(MatSnackBar);

	public notifyError(translationKey?: string | undefined, translationArgs?: unknown[] | undefined) {
		const duration = 8_000;
		this.#snackBar.openFromComponent(ErrorSnackbarComponent, {
			data: {
				translationKey,
				translationArgs,
				duration,
			} as ErrorSnackbarData,
			panelClass: [SimStatusPalette.error, "simSnackBar"],
			duration,
		});
	}

	public notifySuccess(translationKey?: string) {
		const duration = 2_000;
		this.#snackBar.openFromComponent(SuccessSnackbarComponent, {
			data: {
				translationKey,
				duration,
			} as SuccessSnackbarData,
			panelClass: [SimStatusPalette.success, "simSnackBar"],
			duration,
		});
	}

	public notifyInfo(translationKey: string) {
		const duration = 4_000;
		this.#snackBar.openFromComponent(InfoSnackbarComponent, {
			data: {
				translationKey,
				duration,
			} as InfoSnackbarData,
			panelClass: [SimStatusPalette.warn, "simSnackBar"],
			duration,
		});
	}
}
